export function scheduleFullRefresh(delay = 400): void {
  if (typeof window === 'undefined') {
    return
  }

  window.setTimeout(() => {
    window.location.reload()
  }, delay)
}

